<template>
  <div class="custom-actions">
    <a class="btn btn-sm btn-outline-warning"
      :href="`http://gitlab.meta.com.br/${rowData.path}`"
      target="_blank"
      title="Abrir no GitLab">
        <img src="/img/gitlab-icon.png" style="width: 20px">
      </a>
  </div>
</template>

<script>
  export default {
    name: 'custom-actions',
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
  }
  </script>
